export const useAdminStore = defineStore('admin', () => {
  const api = useApi()
  const authStore = useAuthStore()
  const userStore = useUserStore()

  const impersonate = async (params: {
    email: string
  }) => {
    try {
      const { data: { opaqueToken, user } } = await api.admin.impersonate({
        adminOpaqueToken: `${localStorage.getItem('adminOpaqueToken')}`,
        email: params.email,
      })

      userStore.user = user
      authStore.setOpaqueToken(opaqueToken)
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  return { impersonate }
})
